export default "__VITE_ASSET__BzYv17_2__"